// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolType } from '../DataCacheToolEnums';
import { DataCacheTool } from '../DataCacheTool';
export class ArrowLabelDataCacheTool extends DataCacheTool {
    constructor() {
        super();
        this.lineKey = 'property.Line';
        this.ToolType = DataCacheToolType.ArrowLabel;
        this.InitPoints(2);
    }
    MaxPointsCount() {
        return 2;
    }
    MinPointsCount() {
        return 2;
    }
}
